<template>
  <section class="ml-60 py-2">
    <div class="px-2 w-full">
      <div class="p-8 bg-gray-500 rounded-xl">
        <slot></slot>
      </div>
    </div>
  </section>
</template>
